<template>
  <div class="news">
    <nav>
      <TopNav />
    </nav>
    <div class="page1">
      <div class="video-wrapper">
        <video  id=”media” :src="videoUrl" controls  muted :poster="require('../../assets/image/indexBg.jpg')"></video>
        <div class="list">
          <div v-for="(item,itemInd) in newsList" :key="itemInd">
            <div>{{item.title}}</div>
            <div>{{item.subTitle}}</div>
            <button>查看更多</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TopNav from "./components/TopNav.vue";

export default {
  name: "About",
  components: {TopNav},
  data(){
    return {
      videoUrl: 'https://dsmm-elechcy.oss-cn-shenzhen.aliyuncs.com/owe/prod/home/mote.mp4',
      newsList: [
        {title:'雅致医疗开展“关注盆底健康',subTitle: '呵护女性幸福”公益讲座',id :'1'},
        {title:'雅致医疗线上线下心理沙龙活动正式启动',subTitle: '赋能妈妈成为更好的自己',id :'2'},
        {title:'雅致医疗年会',subTitle: '以质量树口碑，以服务得人心',id :'3'},
        {title:'官宣！雅致医疗IP形象“小雅”',subTitle: '软萌上线啦',id :'4'},
        {title:'有颜值有实力！',subTitle: '雅致医疗盆底肌治疗仪获外观专利',id :'5'}
      ]
    }
  }
}
</script>
<style lang="less" scoped>
.news {
  min-height: 100%;
  height: 100%;
  font-size: 16px;
  .page1 {
    height: 100%;
    padding-top: 220px;
    background: url("../../assets/image/loading.png") no-repeat 0 0/100% 100%;
    .video-wrapper {
      video {
        width: 40%;
        max-width: 1024px;
        margin: 0 auto;
        display: block;
      }
      .list {
        display: flex;
        flex-direction: row;
        justify-content: center;
        margin-top: 80px;
        >div {
          margin: 0 15px;
          text-align: center;
          color: #999999;
          line-height: 25px;
        }
        button {
          color: #999999;
          border: 1px solid #999999;
          -webkit-border-radius: 5px;
          border-radius: 5px;
          width: 100px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          background: none;
          margin-top: 18px;
        }
        >div:hover {
          color: #090404;
          button {
            border: 1px solid #090404;
            color: #090404;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/new/News.vue